"use strict";

exports.__esModule = true;
exports.DeviceTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _reactWindow = require("react-window");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Core = require("../../Core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _UserActions = require("../../UserActions");
var _Device = require("../../Device");
var _common = require("../common");
var _Theme = require("../../Theme");
var _MetricValueBatchProvider = require("../MetricValue/MetricValueBatchProvider");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var HeaderRow = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementlegacy__HeaderRow",
  componentId: "sc-1if59uj-0"
})(["display:flex;border-bottom:solid 1px rgba(0,0,0,0.1);width:", "px;"], function (props) {
  return props.width;
});
var HeaderCell = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementlegacy__HeaderCell",
  componentId: "sc-1if59uj-1"
})(["border-right:solid 1px rgba(0,0,0,0.1);display:flex;justify-content:center;align-items:center;"]);
var ItemRow = _styledComponents["default"].button.withConfig({
  displayName: "DeviceTableElementlegacy__ItemRow",
  componentId: "sc-1if59uj-2"
})(["display:flex;border:none;background:none;border-top:solid 1px rgba(0,0,0,0.1);border-bottom:solid 1px rgba(0,0,0,0.1);"]);
var ItemRowLink = ItemRow.withComponent(_reactRouterDom.Link);
var Cell = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementlegacy__Cell",
  componentId: "sc-1if59uj-3"
})(["color:", ";border-right:solid 1px rgba(0,0,0,0.1);display:flex;justify-content:center;align-items:center;overflow:visible;"], (0, _Theme.val)("TextColor"));

/**
 * Displays a virtualized table of devices, repeating the supplied
 * element children for each device.
 */

var DeviceTableElement = exports.DeviceTableElement = function DeviceTableElement(props) {
  props = Object.assign({
    rowGutter: 0,
    itemHeight: 64,
    x: 0,
    y: 0,
    width: 1024,
    height: 768
  }, props);
  var _props = props,
    x = _props.x,
    y = _props.y,
    width = _props.width,
    height = _props.height,
    itemHeight = _props.itemHeight,
    rowGutter = _props.rowGutter,
    backgroundColorSource = _props.backgroundColorSource,
    children = _props.children,
    widgets = _props.widgets,
    render = _props.render,
    onClickAction = _props.onClickAction;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var layoutSettings = _react["default"].useContext(_ConfigurableLayout.LayoutSettingsContext);
  var _useState = (0, _react.useState)(width),
    scrollWidth = _useState[0],
    setScrollWidth = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    renderedRange = _useState2[0],
    setRenderedRange = _useState2[1];
  var outerRef = /*#__PURE__*/_react["default"].createRef();
  var itemSize = itemHeight + rowGutter;
  var listHeight = Math.max(0, height - itemHeight);
  var range = renderedRange || seedListRange((devices == null ? void 0 : devices.length) || 0, listHeight, itemSize);
  var visibleDevices = sliceDevices(devices, range.start, range.stop);
  var onItemsRendered = function onItemsRendered(_ref) {
    var overscanStartIndex = _ref.overscanStartIndex,
      overscanStopIndex = _ref.overscanStopIndex;
    setRenderedRange(function (prev) {
      if (prev && prev.start === overscanStartIndex && prev.stop === overscanStopIndex) {
        return prev;
      }
      return {
        start: overscanStartIndex,
        stop: overscanStopIndex
      };
    });
  };
  (0, _react.useEffect)(function () {
    if (outerRef.current) {
      setScrollWidth(outerRef.current.scrollWidth);
    }
  }, [outerRef]);
  function getColumnWidths() {
    var totalFlex = 0;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      totalFlex += getFlexValue(child);
    }
    var availableWidth = Math.floor(scrollWidth - (children.length - 1));
    var flexWidth = availableWidth / totalFlex;
    return children.map(function (child) {
      return flexWidth * getFlexValue(child);
    });
  }
  var renderHeaders = function renderHeaders() {
    var columnWidths = getColumnWidths();
    return children.map(function (child, index) {
      var width = columnWidths[index];
      var style = {
        width: width,
        height: itemHeight
      };
      var widget = (0, _ConfigurableLayout.getWidget)(widgets, child.type);
      if (!widget || !widget.components.Header) {
        return /*#__PURE__*/_react["default"].createElement(HeaderCell, {
          key: String(index),
          style: style
        }, /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
          level: 4,
          ellipsize: true
        }, child.type));
      }
      var Header = widget.components.Header;
      return /*#__PURE__*/_react["default"].createElement(HeaderCell, {
        key: String(index),
        style: {
          width: width,
          height: itemHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(Header, _extends({}, child.props, {
        width: columnWidths[index],
        height: itemHeight
      })));
    });
  };
  var renderItemWithColorSource = function renderItemWithColorSource(_ref2) {
    var index = _ref2.index,
      style = _ref2.style;
    return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
      deviceUuid: devices[index].uuid
    }, (0, _common.getWidgetColorProps)(props)), function (_ref3) {
      var color = _ref3.color,
        backgroundColor = _ref3.backgroundColor;
      return renderItem({
        index: index,
        style: Object.assign({}, style, {
          color: color,
          backgroundColor: backgroundColor
        })
      });
    });
  };
  var renderItem = function renderItem(_ref4) {
    var index = _ref4.index,
      style = _ref4.style;
    var device = devices[index];
    var columnWidths = getColumnWidths();
    var body = [];
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      var _width = columnWidths[i];
      body.push(/*#__PURE__*/_react["default"].createElement(Cell, {
        key: String(i),
        style: {
          width: _width,
          height: itemHeight
        }
      }, render({
        type: child.type,
        props: Object.assign({}, child.props, {
          x: 0,
          y: 0,
          width: _width,
          height: itemHeight
        }),
        children: child.children
      }, i)));
    }
    if (onClickAction) {
      return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
        value: device
      }, /*#__PURE__*/_react["default"].createElement(_UserActions.UserAction, onClickAction, function (_ref5) {
        var getURL = _ref5.getURL,
          invoke = _ref5.invoke;
        return invoke ? /*#__PURE__*/_react["default"].createElement(ItemRow, {
          key: device.uuid,
          style: Object.assign({}, style, {
            top: style.top + (style.height - itemHeight),
            height: itemHeight
          }),
          onClick: invoke
        }, body, layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_Device.DeviceStatusOverlayController, {
          device: device
        })) : /*#__PURE__*/_react["default"].createElement(ItemRowLink, {
          key: device.uuid,
          style: Object.assign({}, style, {
            top: style.top + (style.height - itemHeight),
            height: itemHeight
          }),
          to: getURL ? getURL() : "."
        }, body, layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_Device.DeviceStatusOverlayController, {
          device: device
        }));
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(ItemRow, {
      key: device.uuid,
      style: Object.assign({}, style, {
        top: style.top + (style.height - itemHeight),
        height: itemHeight
      })
    }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
      value: device
    }, body), layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_Device.DeviceStatusOverlayController, {
      device: device
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_MetricValueBatchProvider.MetricValueBatchProvider, {
    devices: devices,
    visibleDevices: visibleDevices,
    elements: children,
    backgroundColorSource: backgroundColorSource
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      top: y,
      left: x,
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(HeaderRow, {
    style: {
      height: itemHeight,
      width: scrollWidth
    }
  }, renderHeaders()), /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    width: width,
    height: height - itemHeight,
    itemCount: devices == null ? void 0 : devices.length,
    itemSize: itemHeight + rowGutter,
    outerRef: outerRef,
    onItemsRendered: onItemsRendered
  }, backgroundColorSource ? renderItemWithColorSource : renderItem)));
};
function seedListRange(itemCount, listHeight, itemSize) {
  var count = itemCount || 0;
  if (count <= 0) {
    return {
      start: 0,
      stop: -1
    };
  }
  var size = itemSize > 0 ? itemSize : 1;
  var visible = Math.ceil(Math.max(0, listHeight) / size);
  var stopIndex = Math.max(0, Math.min(count - 1, visible - 1));
  return {
    start: 0,
    stop: Math.min(count - 1, stopIndex + 2)
  };
}
function sliceDevices(devices, start, stop) {
  if (!devices || stop < start || start < 0) {
    return [];
  }
  return devices.slice(start, stop + 1);
}
function getFlexValue(input) {
  if (typeof input.props.flex === "number") {
    return input.props.flex || 1;
  } else if (input.props.element != null && input.props.element.props != null) {
    return input.props.element.props.flex || 1;
  }
  return 1;
}